<template lang="pug">
	.string-filter(:class='[state, { selected : query }]')
		.icon
			.criterion(v-show='query.length')
				.icon-close(@click.stop='() => { clear(); close() }')
				p {{ query }}
			.icon-search(@click='toggleOpen')
		.dropdown-body
			.content
				short-text-input(
					:options='{ placeholder : "Search" }'
					:value='query'

					@input='wait( $event, search )'
				)
				.icon-close(@click='close')

</template>

<script>
import ShortTextInput from '@/components/form-inputs/ShortTextInput';
import SimpleSearch from '@/components/SimpleSearch';

export default {
	name : 'string-filter',

	props : {
		timeout : {
			type    : Number,
			default : 200,
		},
		openFilter : {
			type : Boolean
		}
	},

	data : () => ( {
		state : 'close',
		query : ''
	} ),

	watch : {
		query( query ) {
			this.$emit( 'filter', query );
		},

		state( state ) {
			if ( state === 'open' ) {
				this.$emit( 'open' );
			}
		},

		openFilter( openFilter ) {
			if ( !openFilter ) {
				this.close();
			}
		}
	},

	methods : {
		toggleOpen() {
			const { state } = this;

			this.state = state === 'open' ? 'close' : 'open';
		},

		close() {
			this.state = 'close';
		},

		clear() {
			this.query = '';
		},

		clearTimer() {
			if ( this.timer ) {
				window.clearTimeout( this.timer );
			}
		},

		wait( $event, action ) {
			this.clearTimer();

			this.timer = window.setTimeout( () => {
				action( $event );
			}, this.timeout );
		},

		search( query ) {
			this.query = query;
		}
	},

	components : {
		SimpleSearch,
		ShortTextInput
	}
};
</script>

<style scoped lang="scss">

td:first-child {
	.string-filter {

		.dropdown-body {
			left: 0%;
			transform: translate(-20px, 0);

			&::after {
				left: 28px;
			}
		}

		&.open {
			.dropdown-body {
				transform: translate(-20px, 10px);
			}
		}
	}
}

td:nth-last-child(1) {
	.string-filter {

		.dropdown-body {
			transform: translate(calc(-100% + 20px), 0);

			&::after {
				left: calc(100% - 20px);
			}
		}

		&.open {

			.dropdown-body {
				transform: translate(calc(-100% + 20px), 10px);
			}
		}
	}
}

.string-filter {
	border-radius: 30px;
	position: relative;

	&.selected {
		border: 2px solid rgba( $color-primary, 0.25 );
		padding-right: 5px;

		.icon-search {
			margin-left: 5px;
			margin-right: 5px;
		}
	}

	&.open {
		.dropdown-body {
			opacity: 1;
			transform: translate(-50%, 10px);
			pointer-events: all;
		}
	}

	.icon {
		display: flex;
		align-items: center;
		cursor: pointer;
		text-align: center;

		.criterion {
			display: flex;
			align-items: center;
			overflow: hidden;
			border-radius: 30px;

			p {
				font-size: 14px;
				margin-left: 10px;
				white-space: nowrap;
			}

			.icon-close {
				height: 25px;
				width: 25px;
				padding-right: 10px;
				background: rgba( $color-primary, 0.25 );

				&::before,
				&::after {
					height: 10px;
					background: $color-primary;
				}
			}
		}

		.icon-search {
			&::before {
				color: $input-color;
			}
		}
	}

	.dropdown-body {
		position: absolute;
		left: 50%;
		top: 100%;
		transform: translate(-50%, -10px);
		border-radius: 10px;
		border-top-right-radius: 0;
		border-top-left-radius: 0;
		background: white;
		box-shadow: $box-shadow__card;
		opacity: 0;
		pointer-events: none;
		transition: opacity 0.2s ease, transform 0.2s ease;
		border-top: 4px solid $color-primary;
		color: $color-secondary;

		&::after {
			content: ' ';
			position: absolute;
			top: -4px;
			left: 50%;
			border: 5px solid $color-primary;
			border-bottom: 5px solid transparent;
			border-right: 5px solid transparent;
			transform: translate(-50%,-50%) rotate(45deg);
		}

		.content {
			display: flex;
			align-items: center;
			padding-right: 10px;

			.short-text {
				box-shadow: none;
				width: 150px;
			}

		}
	}

}
</style>
